import { render, staticRenderFns } from "./CommentBox.vue?vue&type=template&id=336137a8"
import script from "./CommentBox.ts?vue&type=script&lang=ts&external"
export * from "./CommentBox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports